import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import CustomButton from "../pages/CustomButton";
import { getAuthHeaders } from "../services/useAuth";
import { BASE_URL } from "../config";

export default function DoctorTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const { routeId } = useParams();
  const tableRef = useRef(null);
  const employee_id = searchParams.get("employee_id");

  useEffect(() => {
    console.log(employee_id, routeId);
    if (!routeId || !employee_id) return;

    fetchDoctors();
  }, [routeId, employee_id]);

  const handlePrint = () => {
    if (!tableRef.current) return;

    const printWindow = window.open("", "_blank", "width=1000,height=700");

    printWindow.document.write(`
    <html>
      <head>
        <title>Doctors List</title>
        <style>
          body { font-family: Arial; padding:20px; }
          table { border-collapse: collapse; width:100%; }
          th, td { border:1px solid #000; padding:6px; font-size:12px; }
          th { background:#2563eb; color:white; }
          @page { size: A4 landscape; }
        </style>
      </head>
      <body>
        ${tableRef.current.outerHTML}
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const handleExportToExcel = () => {
    if (!data || data.length === 0) {
      alert("No data available to export");
      return;
    }

    const headers = [
      "S.No",
      "Code",
      "Doctor Name",
      "Mobile",
      "City",
      "State",
      "Area",
      "Address",
    ];

    const rows = data.map((row, index) => [
      index + 1,
      row.code || "",
      row.name || "",
      row.mobile || "",
      row.city || "",
      row.state || "",
      row.area || "",
      row.address || "",
    ]);

    let csvContent = headers.join(",") + "\n";

    rows.forEach((row) => {
      csvContent +=
        row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(",") +
        "\n";
    });

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `doctors_route_${routeId}.csv`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  const fetchDoctors = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${BASE_URL}/api/reports/employee-route-retailers?employee_id=${employee_id}&route_id=${routeId}&retailer_type=doctor`,
        {
          headers: getAuthHeaders(),
        },
      );

      const result = await response.json();
      setData(result.data || []);
    } catch (error) {
      console.error("Error fetching doctors:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 bg-white rounded-xl shadow">
      <h2 className="text-lg font-semibold mb-4 text-center">Doctors List</h2>

      {loading ? (
        <p className="text-center">Loading...</p>
      ) : (
        <div className="overflow-x-auto" ref={tableRef}>
          <table className="min-w-full border border-gray-300 text-sm">
            <thead className="bg-blue-500 text-white">
              <tr>
                {[
                  "S.No",
                  "Code",
                  "Doctor Name",
                  "Mobile",
                  "City",
                  "State",
                  "Area",
                  "Address",
                ].map((head) => (
                  <th
                    key={head}
                    className="border border-gray-300 px-3 py-2 text-left font-semibold"
                  >
                    {head}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center py-4">
                    No doctors found
                  </td>
                </tr>
              ) : (
                data.map((row, idx) => (
                  <tr
                    key={row.id}
                    className="odd:bg-white even:bg-gray-50 hover:bg-cyan-50"
                  >
                    <td className="border px-3 py-2">{idx + 1}</td>

                    <td className="border px-3 py-2 text-blue-600 font-medium">
                      {row.code}
                    </td>

                    <td className="border px-3 py-2">{row.name}</td>

                    <td className="border px-3 py-2">{row.mobile || "-"}</td>

                    <td className="border px-3 py-2">{row.city || "-"}</td>

                    <td className="border px-3 py-2">{row.state || "-"}</td>

                    <td className="border px-3 py-2">{row.area || "-"}</td>

                    <td className="border px-3 py-2 max-w-xs truncate">
                      {row.address || "-"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      <div className="flex justify-center gap-4 mt-4">
        <CustomButton onClick={handlePrint} label="Print" variant="print">
          🖨
        </CustomButton>
        <CustomButton
          onClick={handleExportToExcel}
          label="Export"
          variant="export"
        >
          📥
        </CustomButton>
      </div>
    </div>
  );
}
